import PlusIcon from "@assets/icons/plusIcon"
import { GoogleIcon } from "@assets/icons/google"
import { Button } from "@components/Button"
import styles from "./ConnectGoogleAccComponent.module.css"
import useAuth from "@hooks/useAuth"
import React, { useEffect } from "react"
import { useLocation } from "react-router-dom"
// import useBooking from "@hooks/useBooking"

const origin = import.meta.env.VITE_APP_URL || "http://localhost:5174"

const ConnectGoogleAccComponent = ({ setSignedIn }) => {
  const { handleGoogleOauth } = useAuth()
  // const { handleIsAccessTokenValid } = useBooking()
  const location = useLocation()
  //   const navigate = useNavigate()

  const openPopupWindow = (url) => {
    const width = 1000
    const height = 600
    const left = window.screen.width / 2 - width / 2
    const top = window.screen.height / 2 - height / 2
    return window.open(
      url,
      "GoogleOAuth",
      `width=${width},height=${height},left=${left},top=${top}`
    )
  }

  const handleClick = async () => {
    const data = await handleGoogleOauth()
    if (data) {
      const { authUrl } = data
      const authWindow = openPopupWindow(authUrl)

      window.addEventListener(
        "message",
        function (event) {
          if (event.origin === origin) {
            if (event.data.type === "oauth-success") {
              setSignedIn(true)
            }
          }
        },
        false
      )

      const pollTimer = setInterval(() => {
        if (authWindow.closed) {
          clearInterval(pollTimer)
        }
      }, 1000)
    }
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.hash.slice(1))
    const token = searchParams.get("access_token")

    if (token) {
      // console.log("Access Token:", token)
      setSignedIn(true)
      localStorage.setItem("googleAccessToken", token)
      // Store the token or use it as needed

      // Remove the token from the URL
      // navigate(location.pathname, { replace: true })
    }
  }, [location])

  return (
    <div className={styles.manageAppointmentPage}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <h2 className={styles.headingOne}>Connect to Google Account</h2>
          <p className={styles.headingTwo}>
            Your meeting is secure with Google Meet, Start Scheduling your
            Online Booking Now
          </p>
        </div>
        <Button
          variant="transparent"
          className={styles.googleConnectButton}
          onClick={handleClick}
        >
          <GoogleIcon />
          CONNECT TO START
        </Button>

        <div className={styles.plusIconWrapper}>
          <PlusIcon />
        </div>
      </div>
    </div>
  )
}

export default ConnectGoogleAccComponent
